import {printoutPalette} from "../../core/printoutPalette";
import {PRINTOUT_CONTAINER_COLUMN_GAP_MM, PRINTOUT_CONTAINER_SPACE_ABOVE_OPTIONS} from "./printoutContainerOptions";

export const containerBlockSx = {
    "& [data-printout-container-space-above]": {
        marginBottom: "4mm",
    },
    ...Object.fromEntries(PRINTOUT_CONTAINER_SPACE_ABOVE_OPTIONS.map(space => [
        `& [data-printout-container-space-above="${space}"]`,
        {marginTop: `${space}mm`},
    ])),
    "& .printout-container-columns, & .printout-rendered-container": {
        // Reset at every container so a nested layout never inherits its parent's rules.
        "--printout-column-separator": "none",
        alignItems: "stretch",
        boxSizing: "border-box",
        display: "flex",
        gap: `${PRINTOUT_CONTAINER_COLUMN_GAP_MM}mm`,
        minWidth: 0,
        width: "100%",
        // Keep ordinary containers together; oversized ones may still fragment.
        "@media print": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
        },
    },
    '& [data-printout-container-separators="true"]': {
        "--printout-column-separator": `1px solid ${printoutPalette.border}`,
    },
    // Expose nested contentDOM columns as flex items.
    "& .printout-container-columns > [data-node-view-content-react]": {
        display: "contents",
    },
    "& .printout-container-column": {
        flex: "1 1 0",
        minWidth: 0,
        position: "relative",
    },
    "& .printout-container-column + .printout-container-column::before": {
        borderLeft: "var(--printout-column-separator)",
        bottom: 0,
        content: '""',
        left: `calc(-${PRINTOUT_CONTAINER_COLUMN_GAP_MM / 2}mm - 0.5px)`,
        pointerEvents: "none",
        position: "absolute",
        top: 0,
    },
    "& .printout-container-column > :first-child:not([data-printout-container-space-above])": {
        marginTop: 0,
    },
    "& .printout-container-column > :last-child, & .printout-container-column > p:last-child": {
        marginBottom: 0,
    },
};
